var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareWhatsappIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 67,
    height: 67,
    viewBox: "0 0 67 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "whatsappshare",
    transform: "translate(0.424 0.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_09.whatsapp",
    "data-name": "09.whatsapp",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "background",
    cx: 33.5,
    cy: 33.5,
    r: 33.5,
    transform: "translate(-0.424 -0.1)",
    fill: "#29a71a"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icon",
    transform: "translate(9.404 9.479)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24425",
    "data-name": "Path 24425",
    d: "M74.373,40.116A23.923,23.923,0,0,0,36.048,67.792L33.51,80.115a.912.912,0,0,0,.145.715.925.925,0,0,0,.982.381l12.078-2.863A23.919,23.919,0,0,0,74.373,40.116ZM70.607,70.172a18.737,18.737,0,0,1-21.578,3.507l-1.683-.833-7.4,1.754.022-.092L41.5,67.055l-.824-1.626a18.729,18.729,0,0,1,29.934-21.74,1,1,0,0,0,.1.1A18.728,18.728,0,0,1,70.607,70.172Z",
    transform: "translate(-33.447 -33.024)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24426",
    "data-name": "Path 24426",
    d: "M85.15,80.562c-.907,1.429-2.341,3.178-4.143,3.612-3.156.763-8,.026-14.029-5.594l-.075-.066c-5.3-4.914-6.677-9-6.344-12.249.184-1.841,1.719-3.507,3.012-4.594a1.723,1.723,0,0,1,2.7.618l1.951,4.384A1.714,1.714,0,0,1,68,68.427l-.986,1.28a1.7,1.7,0,0,0-.153,1.894,18.432,18.432,0,0,0,3.345,3.713,19.522,19.522,0,0,0,4.634,3.319,1.675,1.675,0,0,0,1.837-.386l1.144-1.153a1.754,1.754,0,0,1,1.71-.438l4.634,1.315a1.754,1.754,0,0,1,.982,2.591Z",
    transform: "translate(-48.648 -48.881)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareWhatsappIcon);
export default __webpack_public_path__ + "static/media/share-whatsapp-icon.0287897fcc5ce4a0185e6ed9992e716e.svg";
export { ForwardRef as ReactComponent };